<template>
  <div class="bg-white p-4">
    <h1 class="mb-4 p-2 text-center page-title">
      <i class="mdi mdi-chart-bar-stacked"></i> Dashboard
    </h1>

    <div class="row d-flex justify-content-center">
      <div class="col-md-4 dash-item">
        <div class="box">
          <span class="value text-custom-primary">{{
            nbChantiers ? nbChantiers : ''
          }}</span>
          <span class="title">Chantiers</span>
        </div>
        <div class="icon-case">
          <a style="cursor: pointer" @click="listChantiers"
            ><img src="@/assets/images/dashboard/buildings.png" alt="chantiers"
          /></a>
        </div>
      </div>
      <div class="col-md-4 dash-item">
        <div class="box">
          <span class="value text-custom-primary">{{
            nbEmployes ? nbEmployes : ''
          }}</span>
          <span class="title">Salariés</span>
        </div>
        <div class="icon-case">
          <a style="cursor: pointer" @click="listEmployes">
            <img src="@/assets/images/dashboard/users.png" alt="salariés" />
          </a>
        </div>
      </div>
      <!-- <div class="col-md-3 dash-item">
        <div class="box">
          <span class="value text-custom-primary">1234</span>
          <span class="title">Chantiers</span>
        </div>
        <div class="icon-case">
          <img src="@/assets/images/dashboard/buildings.png" alt="hello" />
        </div>
      </div> -->
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-10">
        <div class="form-group">
          <label for="chantier">Choisir un chantier </label>
          <v-custom-select
            label="nom"
            id="chantier"
            :options="chantiers"
            :reduce="(chantier) => chantier.uuid"
            v-model="selectedChantier"
            placeholder="Choisir un chantier"
            @input="onChantierSelect"
          >
            <template v-slot:option="{ nom }">
              <h5 style="margin: 0">{{ nom }}</h5>
            </template>
            <template #no-options> Aucune données </template>
            <template #search="{ attributes, events }">
              <input
                class="custom-select-height vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-custom-select>
        </div>
      </div>
    </div>

    <Calendar ref="cal" :uuid="uuid" :selectedChantier="chantier" />
  </div>
</template>

<script>
import REPORTING from '@/http/reporting';
import Calendar from './Calendar.vue';
import namesChantier from '@/constants/routes/chantier/chantier';

export default {
  name: 'Dashboard',
  data() {
    return {
      title: 'Dashboard',
      selectedChantier: null,
      nbChantiers: null,
      nbEmployes: null,
      chantiers: [],
      chantier: null,
      uuid: null,
      routesChantier: namesChantier,
    };
  },
  components: { Calendar },
  methods: {
    onChantierSelect() {
      console.log(
        'Chantier selected : ',
        this.getChantier(this.selectedChantier)
      );
      if (this.selectedChantier) {
        let c = this.getChantier(this.selectedChantier);

        this.uuid = c.uuid;
        this.chantier = c.nom;
      } else {
        this.uuid = null;
        this.chantier = null;
      }
      this.$refs.cal.setThings({ uuid: this.uuid, chantier: this.chantier });
    },

    init() {
      window.axios.get(REPORTING.REPORTING).then((resp) => {
        console.log('Data is here', resp.data);
        this.chantiers = resp.data.chantiers;
        this.nbChantiers = resp.data.nbChantiers;
        this.nbEmployes = resp.data.nbEmployes;
      });
    },

    listEmployes() {
      return this.$router.push({
        name: 'rh_employe',
      });
    },
    listChantiers() {
      return this.$router.push({
        name: this.routesChantier.base,
      });
    },

    getChantier(uuid) {
      return this.chantiers.find((c) => c.uuid === uuid);
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.dash-item {
}

.dash-item {
  width: 250px;
  height: 150px;
  background: white;
  margin: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

  .icon-case {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -20px;
    left: 0;
    background: #2c4978;
    padding: 0.5rem;
    border-radius: 5px;

    img {
      width: 100%;
    }
  }
}
.dash-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  background: url('~@/assets/images/bg-pattern.png');
  background-size: cover;
  background-position: bottom;
  border-top: 1px solid rgb(0, 0, 0);
}

.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .value {
    font-size: 2rem;
    font-weight: bold;
  }

  .title {
    font-size: 1.3rem;
    font-weight: bold;
  }
}

.page-title {
  font-size: 3rem;
  background: #d0e2fe;
  border-bottom: 1px solid #4366a0;
}
</style>
